import React from 'react';
import HealthScoreCard from '../components/home/HealthScoreCard';
import TodayCard from '../components/home/TodayCard';

// Home — the calm daily cockpit (glance layer). The report-card score + a
// tap-through summary of today's log. The twin moved to /you; logging is the
// bottom-nav mic (/log); the full log lives in entries (nested under Data).

const HomePage = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <HealthScoreCard />
      <TodayCard />
    </div>
  );
};

export default HomePage;
